import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Component to display name description and logo.
 */
@Component({
    selector: 'ssf-brand-identifier',
    template: require('./brand-identifier.component.html'),
    styles: [require('./brand-identifier.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BrandIdentifierComponent {
    @Input() public name: string;
    @Input() public description: string;
    @Input() public logo: Blob;
    @Input() public logoAlt: Blob;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/brand-identifier/brand-identifier.component.ts